import { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext } from 'commons-ui';
import { formatDataAsOrginalLayout, updateLayoutInLocal } from 'pages/dashboard/homePageLayout/utils/helper';
import { IVersionBasedHomePageLayout, IViewHomePageLayoutOrder } from 'pages/dashboard/homePageLayout/utils/model';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const location = useLocation();
	const { showAlert } = useContext(AppContext);

	const updateLayout = (updatedData: IViewHomePageLayoutOrder) => {
		setShowLoader(true);
		try {
			setShowLoader(true);
			const parentRowData: IVersionBasedHomePageLayout = _get(location, ['state', 'parentRowData']);
			const existingData: IViewHomePageLayoutOrder = _get(location, ['state', 'rowData']);
			updateLayoutInLocal(parentRowData, formatDataAsOrginalLayout(existingData), formatDataAsOrginalLayout(updatedData));
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: IViewHomePageLayoutOrder) => {
		updateLayout(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: _get(location, ['state', 'rowData']),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
